import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { useUserContext } from '../../auth/UserProvider'
import { START_DATE_QUARTER_DATA, TODAY_DATE } from '../../common/constants'

import SearchCard from './SearchCard'
import SearchResults from './SearchResults'
import StatisticsCard from './StatisticsCard'
import {
  useShippingsTracking,
  useShippingStates,
} from '../../services/shippingsTracking'

const ShippingsSearch = ({ onClickResolveIncident }) => {
  const { clientCode, centres, statusList } = useUserContext()

  const [search, setSearch] = useState('')

  const {
    isFetching,
    refetch,
    data: searchResults,
  } = useShippingsTracking({
    filters: {
      clientCode,
      centres,
      search,
      rowsPerPage: 5,
      page: 0,
      dateFrom: START_DATE_QUARTER_DATA,
      dateTo: TODAY_DATE,
    },
    config: {
      enabled: false,
    },
    statusList,
  })
  const shippingCodes =
    searchResults?.shippings?.map(item => item.info.shippingCode) || []

  const { data: shippingsStates, isLoading: isLoadingShippingsStates } =
    useShippingStates(shippingCodes)
  useEffect(() => {
    if (search !== '') {
      refetch()
    }
  }, [search, refetch])

  return (
    <>
      <SearchCard
        onSearch={setSearch}
        showNotFoundWarning={searchResults?.shippings.length === 0}
      />
      <StatisticsCard />
      <SearchResults
        isFetching={isFetching}
        isLoadingShippingsStates={isLoadingShippingsStates}
        searchResults={searchResults?.shippings}
        states={shippingsStates}
        onClickResolveIncident={onClickResolveIncident}
      />
    </>
  )
}

ShippingsSearch.propTypes = {
  onClickResolveIncident: PropTypes.func,
}

export default ShippingsSearch
